import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ParentUiState {
  /** Яку дитину зараз дивиться батько. Тільки UI-вибір, не дані. */
  selectedLearnerId: string | null;
  select: (learnerId: string) => void;
}

export const useParentStore = create<ParentUiState>()(
  persist(
    (set) => ({
      selectedLearnerId: null,
      select: (learnerId) => set({ selectedLearnerId: learnerId }),
    }),
    { name: 'lk.parent', storage: createJSONStorage(() => localStorage) },
  ),
);
